// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__2vhPh","info":"UpdateTermsInfo_info__1kzdw"};